import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "./referential"
import type { UniverseName } from "./universe.enum"

export type FamilyName = keyof typeof familyEnum
export const familyEnum = {
  // MEDICAL_DEVICES
  ORTHOPEDICS: {
    label: "Orthopédie",
    universe: "MEDICAL_DEVICES",
    rank: 1,
  },
  COMPRESSION: {
    label: "Compression",
    universe: "MEDICAL_DEVICES",
    rank: 2,
  },
  INCONTINENCE: {
    label: "Incontinence",
    universe: "MEDICAL_DEVICES",
    rank: 3,
  },
  ORAL_NUTRITION: {
    label: "Nutrition orale",
    universe: "MEDICAL_DEVICES",
    rank: 4,
  },
  WHITE_PRODUCT_LINE: {
    label: "Gamme blanche",
    universe: "MEDICAL_DEVICES",
    rank: 5,
  },
  WOUND_DRESSINGS: {
    label: "Pansements techniques",
    universe: "MEDICAL_DEVICES",
    rank: 6,
  },
  HOMECARE: {
    label: "MAD - HAD",
    universe: "MEDICAL_DEVICES",
    rank: 7,
  },
  DIABETES_NEEDLES: {
    label: "Diabète - Aiguilles",
    universe: "MEDICAL_DEVICES",
    rank: 8,
  },
  DIABETES_TEST_STRIPS: {
    label: "Diabète - Bandelettes",
    universe: "MEDICAL_DEVICES",
    rank: 9,
  },

  // SUPPLEMENTS_AND_NATURAL_REMEDIES
  DIETARY_SUPPLEMENTS: {
    label: "Complément alimentaire",
    universe: "SUPPLEMENTS_AND_NATURAL_REMEDIES",
    rank: 10,
  },
  PHYTOTHERAPY: {
    label: "Phytothérapie",
    universe: "SUPPLEMENTS_AND_NATURAL_REMEDIES",
    rank: 11,
  },
  AROMATHERAPY: {
    label: "Aromathérapie",
    universe: "SUPPLEMENTS_AND_NATURAL_REMEDIES",
    rank: 12,
  },

  // FAMILY_HEALTH_COUNSELING
  HOMEOPATHY: {
    label: "Homéopathie",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 13,
  },
  PAIN_AND_FEVER: {
    label: "Douleurs & fièvre",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 14,
  },
  EAR_NOSE_THROAT: {
    label: "ORL",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 15,
  },
  DIGESTION: {
    label: "Digestion",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 16,
  },
  SLEEP_AND_STRESS: {
    label: "Sommeil & stress",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 17,
  },
  VITAMINS_DEFICIENCY_AND_IMMUNITY: {
    label: "Vitamine, Carence & Immunité",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 18,
  },
  EYE_HEALTH: {
    label: "Vision",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 19,
  },
  CIRCULATION: {
    label: "Circulation",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 20,
  },
  MOSQUITOES_AND_LICE: {
    label: "Moustiques & poux",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 21,
  },
  JOINT_AND_MUSCLE: {
    label: "Articulation & Muscle",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 22,
  },
  MEMORY_TOBACCO_AND_VITALITY: {
    label: "Mémoire, Tabac & Vitalité",
    universe: "FAMILY_HEALTH_COUNSELING",
    rank: 23,
  },

  // HYGIENE_BEAUTY
  ORGANIC_BEAUTY: {
    label: "Beauté bio",
    universe: "HYGIENE_BEAUTY",
    rank: 24,
  },
  MAKEUP: {
    label: "Maquillage",
    universe: "HYGIENE_BEAUTY",
    rank: 25,
  },
  FOOT_CARE: {
    label: "Soins de pieds",
    universe: "HYGIENE_BEAUTY",
    rank: 26,
  },
  HAIR_CARE: {
    label: "Capillaires",
    universe: "HYGIENE_BEAUTY",
    rank: 27,
  },
  SOLAR_PROTECTION: {
    label: "Solaire",
    universe: "HYGIENE_BEAUTY",
    rank: 28,
  },
  SKIN_CARE: {
    label: "Beauté",
    universe: "HYGIENE_BEAUTY",
    rank: 29,
  },
  ORAL_CARE: {
    label: "Hygiène et soins buccodentaires",
    universe: "HYGIENE_BEAUTY",
    rank: 30,
  },
  INTIMATE_HYGIENE: {
    label: "Hygiène intime",
    universe: "HYGIENE_BEAUTY",
    rank: 31,
  },
  DEODORANTS: {
    label: "Déodorants",
    universe: "HYGIENE_BEAUTY",
    rank: 32,
  },
  SHOWER_GELS: {
    label: "Hygiène corps",
    universe: "HYGIENE_BEAUTY",
    rank: 33,
  },

  // RX_MEDICATIONS
  BRAND_NAME_DRUGS: {
    label: "Princeps",
    universe: "RX_MEDICATIONS",
    rank: 34,
  },
  GENERICS_COVERED_REIMBURSABLE: {
    label: "Génériques répertoire remboursé",
    universe: "RX_MEDICATIONS",
    rank: 35,
  },
  GENERICS_NON_COVERED_REIMBURSABLE: {
    label: "Génériques hors répertoire remboursé",
    universe: "RX_MEDICATIONS",
    rank: 36,
  },
  GENERICS_COVERED_NON_REIMBURSABLE: {
    label: "Génériques répertoire non remboursé",
    universe: "RX_MEDICATIONS",
    rank: 37,
  },
  GENERICS_NON_COVERED_NON_REIMBURSABLE: {
    label: "Génériques hors répertoire non remboursé",
    universe: "RX_MEDICATIONS",
    rank: 38,
  },
  SUBSTITUTABLE_HYBRIDS: {
    label: "Hybrides substituables",
    universe: "RX_MEDICATIONS",
    rank: 39,
  },
  BIOSIMILARS: {
    label: "Biosimilaires",
    universe: "RX_MEDICATIONS",
    rank: 40,
  },
  BIOSIMILARS_NON_SUBSTITUTABLE: {
    label: "Biosimilaires non substituables",
    universe: "RX_MEDICATIONS",
    rank: 41,
  },
  VACCINES_FLU: {
    label: "Vaccins grippe",
    universe: "RX_MEDICATIONS",
    rank: 42,
  },
  VACCINES_OTHER: {
    label: "Autres Vaccins",
    universe: "RX_MEDICATIONS",
    rank: 43,
  },

  // HEALTH_SERVICES
  PREVENTION: {
    label: "Prévention",
    universe: "HEALTH_SERVICES",
    rank: 44,
  },
  SCREENING: {
    label: "Dépistage",
    universe: "HEALTH_SERVICES",
    rank: 45,
  },
  CONSULTATIONS: {
    label: "Entretiens",
    universe: "HEALTH_SERVICES",
    rank: 46,
  },

  // VETERINARY
  ANTI_PARASITICS: {
    label: "Vétérinaires - Anti-parasitaires",
    universe: "VETERINARY",
    rank: 47,
  },
  OTHER_VETERINARY_CARE: {
    label: "Vétérinaires - Autres soins",
    universe: "VETERINARY",
    rank: 48,
  },

  // BABY
  BABY_FORMULA: {
    label: "Lait infantile",
    universe: "BABY",
    rank: 49,
  },
  BOTTLES_AND_FEEDING: {
    label: "Biberonnerie",
    universe: "BABY",
    rank: 50,
  },
  BABY_CARE_AND_HYGIENE: {
    label: "Bébé - Soins & hygiène",
    universe: "BABY",
    rank: 51,
  },
  BABY_ACCESSORIES: {
    label: "Bébé - Accessoires Puériculture",
    universe: "BABY",
    rank: 52,
  },
} as const satisfies ReferentialEnum<{
  universe: UniverseName
  rank: number
}>

export const familyReferential = referentialEnumToReferentialCodeList(
  familyEnum,
).sort((a, b) => a.rank - b.rank)

export type ChallengeFamilyName = keyof typeof challengeFamilyEnum

export const challengeFamilyEnum = {
  ORTHOPEDICS: {
    label: "Orthopédie",
  },
  COMPRESSION: {
    label: "Compression",
  },
  INCONTINENCE: {
    label: "Incontinence",
  },
  ORAL_NUTRITION: {
    label: "Nutrition orale",
  },
  WHITE_PRODUCT_LINE: {
    label: "Gamme blanche",
  },
  GENERICS: {
    label: "Génériques",
  },
  BIOSIMILARS: {
    label: "Biosimilaires",
  },
  VACCINES_FLU: {
    label: "Vaccins grippe",
  },
} as const satisfies ReferentialEnum

export const challengeFamilyReferential =
  referentialEnumToReferentialCodeList(challengeFamilyEnum)
